import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../app-logo/logo-data'
import style from './AppBar.style'

const AppBarInner = ({ classes }) => {
  return (
    <AppBar
      position="static"
      color="inherit"
      elevation={0}
      style={{ padding: '24px' }}
    >
      <Toolbar className={classes.toolbarInner}>
        <LogoData />
      </Toolbar>
    </AppBar>
  )
}

export default style(AppBarInner)
